import { initSelector } from './selector'
import { HashScroll } from './hash-scroll'
import { initFlexible } from './flexibles'
import { MenuPrimary } from './menu-primary'
import { Modal } from './modal'
import { Search } from './search'
import { Slider } from './slider'
import { Tabs } from './tabs'
import { Sticky } from './sticky'
import { Tracking } from './tracking'
import { TableContent } from './table-content'
import './active-script.js'
import {BackToTop} from "./back-to-top"
import {ScrollDown} from "./scroll-down"
import {Link} from './link'
import {Chatbot} from "./chatbot";
import './marketo'
import {BannerTop} from "./banner-top.js";
import {CalculatorIva} from "./calculator-iva.js";
import {CalculatorFreelance} from "./calculator-freelance.js";
import {CalculatorSickLeave} from "./calculator-sick-leave.js";
import {CalculatorUnemployment} from "./calculator-unemployment.js";
import {CalculatorSickCommon} from "./calculator-sick-common.js";
import {CalculatorMaternity} from "./calculator-maternity.js";
import { SentryConfig } from './sentry-config.js'

new SentryConfig()
new Tabs(true)
new Modal()
new Search()
new Slider()
new Sticky()
new HashScroll()
new Tracking()
new MenuPrimary()
new TableContent()
new BackToTop()
new ScrollDown()
new Link()
new Chatbot()
new BannerTop()
new CalculatorIva()
new CalculatorFreelance()
new CalculatorSickLeave()
new CalculatorUnemployment()
new CalculatorSickCommon()
new CalculatorMaternity()

initFlexible()
initSelector()
